import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { RootLayout } from '@/layouts/RootLayout'
import { FallbackLayout } from '@/layouts/FallbackLayout'

const PageHome = lazy(() => import('@/app/page'))
const PageCancelarConsulta = lazy(() => import('@/app/cancelar-consulta/page'))
const PageTeleconsulta = lazy(() => import('@/app/teleconsulta/page'))
const PageEscolhaUsuario = lazy(() => import('@/app/escolha-usuario/page'))
const PageConfirmarHorario = lazy(() => import('@/app/confirmar-horario/page'))
const PageEscolhaHorario = lazy(() => import('@/app/escolha-horario/page'))
const PageSucessoAgendamento = lazy(
  () => import('@/app/sucesso-agendamento/page')
)
const PageAgendarConsulta = lazy(() => import('@/app/agendar-consulta/page'))
const PagePagamento = lazy(() => import('@/app/pagamento/page'))
const PageLocal = lazy(() => import('@/app/local/page'))
const PagePaciente = lazy(() => import('@/app/paciente/page'))
const PageEmManutencao = lazy(() => import('@/app/em-manutencao/page'))
const PageConsultaCancelada = lazy(
  () => import('@/app/consulta-cancelada/page')
)
const PageDevelopInfo = lazy(() => import('@/app/develop-info/page'))
const PageConfirmarPaciente = lazy(
  () => import('@/app/confirmar-paciente/page')
)
const PageFallbackSugestaoCobertura = lazy(
  () => import('@/app/fallback/sugestao-cobertura/page')
)
const PageFallbackSessentaDias = lazy(
  () => import('@/app/fallback/sessenta-dias/page')
)
const PageFallbackTeleconsultaPacienteExpirada = lazy(
  () => import('@/app/fallback/teleconsulta-do-paciente-expirada/page')
)
const PageFallbackEspecialidadeFaixaEtaria = lazy(
  () =>
    import(
      '@/app/fallback/especialidade-nao-dispoe-atendimento-para-faixa-etaria/page'
    )
)
const PageFallbackEspecialidadeOnline = lazy(() =>
  import('@/app/fallback/especialidade-sem-atendimento-online/page').then(
    (m) => ({
      default: m.default
    })
  )
)
const PageFallbackGenero = lazy(
  () =>
    import(
      '@/app/fallback/genero-sem-atendimento-para-especialidade-no-local/page'
    )
)
const PageFallbackEspecialidadeLocal = lazy(
  () =>
    import(
      '@/app/fallback/especialidade-sem-atendimento-no-local-escolhido/page'
    )
)
const PageFallbackSugestaoExpansao = lazy(
  () => import('@/app/fallback/sugestao-expansao-atendimento/page')
)
const PageFallbackSugestaoSessentaDias = lazy(
  () => import('@/app/fallback/sugestao-sessenta-dias/page')
)
const PageFallbackPlano = lazy(
  () =>
    import(
      '@/app/fallback/plano-sem-atendimento-para-especialidade-no-local/page'
    )
)
const PageFallbackConsultaExpirada = lazy(
  () => import('@/app/fallback/consulta-expirada/page')
)
const PageFallbackErroGenerico = lazy(
  () => import('@/app/fallback/erro-generico/page')
)
const PageFallbackTeleconsultaMedicoExpirada = lazy(
  () => import('@/app/fallback/teleconsulta-do-medico-expirada/page')
)
const PageFallbackTeleconsultaCancelada = lazy(
  () => import('@/app/fallback/teleconsulta-cancelada/page')
)
const PageFallbackConsultaCancelada = lazy(
  () => import('@/app/fallback/consulta-cancelada/page')
)
const PageFallbackPE = lazy(
  () => import('@/app/fallback/sulamerica-individual-pe/page')
)
const PageNotFound = lazy(() => import('@/app/not-found'))

export function AppRoutes() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route
          path="/especialidade-medico"
          element={<Navigate to="/" replace />}
        />
        <Route path="/" element={<RootLayout />}>
          <Route index element={<PageHome />} />
          <Route
            path="cancelar-consulta/:schedulingId"
            element={<PageCancelarConsulta />}
          />
          <Route
            path="teleconsulta/:userType/:schedulingId"
            element={<PageTeleconsulta />}
          />
          <Route path="escolha-usuario" element={<PageEscolhaUsuario />} />
          <Route path="confirmar-horario" element={<PageConfirmarHorario />} />
          <Route path="escolha-horario" element={<PageEscolhaHorario />} />
          <Route
            path="sucesso-agendamento"
            element={<PageSucessoAgendamento />}
          />
          <Route path="agendar-consulta" element={<PageAgendarConsulta />} />
          <Route path="pagamento" element={<PagePagamento />} />
          <Route path="local" element={<PageLocal />} />
          <Route path="paciente/*" element={<PagePaciente />} />
          <Route path="em-manutencao" element={<PageEmManutencao />} />
          <Route
            path="consulta-cancelada"
            element={<PageConsultaCancelada />}
          />
          <Route path="develop-info" element={<PageDevelopInfo />} />
          <Route
            path="confirmar-paciente"
            element={<PageConfirmarPaciente />}
          />
          <Route path="fallback" element={<FallbackLayout />}>
            <Route
              path="sugestao-cobertura"
              element={<PageFallbackSugestaoCobertura />}
            />
            <Route
              path="sessenta-dias"
              element={<PageFallbackSessentaDias />}
            />
            <Route
              path="teleconsulta-do-paciente-expirada"
              element={<PageFallbackTeleconsultaPacienteExpirada />}
            />
            <Route
              path="especialidade-nao-dispoe-atendimento-para-faixa-etaria"
              element={<PageFallbackEspecialidadeFaixaEtaria />}
            />
            <Route
              path="especialidade-sem-atendimento-online"
              element={<PageFallbackEspecialidadeOnline />}
            />
            <Route
              path="genero-sem-atendimento-para-especialidade-no-local"
              element={<PageFallbackGenero />}
            />
            <Route
              path="especialidade-sem-atendimento-no-local-escolhido"
              element={<PageFallbackEspecialidadeLocal />}
            />
            <Route
              path="sugestao-expansao-atendimento"
              element={<PageFallbackSugestaoExpansao />}
            />
            <Route
              path="sugestao-sessenta-dias"
              element={<PageFallbackSugestaoSessentaDias />}
            />
            <Route
              path="plano-sem-atendimento-para-especialidade-no-local"
              element={<PageFallbackPlano />}
            />
            <Route
              path="consulta-expirada"
              element={<PageFallbackConsultaExpirada />}
            />
            <Route
              path="erro-generico"
              element={<PageFallbackErroGenerico />}
            />
            <Route
              path="teleconsulta-do-medico-expirada"
              element={<PageFallbackTeleconsultaMedicoExpirada />}
            />
            <Route
              path="teleconsulta-cancelada"
              element={<PageFallbackTeleconsultaCancelada />}
            />
            <Route
              path="consulta-cancelada"
              element={<PageFallbackConsultaCancelada />}
            />
            <Route
              path="sulamerica-individual-pe"
              element={<PageFallbackPE />}
            />
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </Route>
      </Routes>
    </Suspense>
  )
}
